<div class="auth-login" appClickAnywhere (clickNature)="getClickNature($event)">
  <div class="left-col">
    <div class="overlay"></div>
    <div class="content">
      <h1 i18n="Title for the service introduction on the login page@@NATURAL_WAY">The natural way to date people!</h1>
      <p class="hook" i18n="Description for the service introduction on the login page@@DATING_PROJECT_TEXT">Discover THE new online dating platform! <br/>Stories, quizzes, innovative concept to find love or meet new people.</p>
      <div class="info">
        <div class="item">
          <span class="material-symbols-outlined lightbulb">
            lightbulb
          </span>
        </div>
        <p i18n="Marketing info for the service introduction on the login page@@FUN_CONCEPT">A new and fun concept based on stories.</p>
      </div>
      <div class="info">
        <div class="item">
          <span class="material-symbols-outlined photos">
            photo_library
          </span>
        </div>
        <p i18n="Marketing info for the service introduction on the login page@@100_COMPLETE_PROFILES">100% complete profiles with minimum one photo.</p>
      </div>
    </div>
  </div>

  <div class="right-col">
    <div class="overlay"></div>
    <div class="content">
      <app-header></app-header>

      <form 
        [formGroup]="authFormGroup" 
        (ngSubmit)="onSubmit()"
      >
        <div class="field">
          <h2 i18n="Login section header@@LOGIN">Log in</h2>
          @if(inputs.login){
            <div class="input-holder">
              <input
                id="login"
                type="text"
                formControlName="loginCtrl"
                placeholder="Email or phone number"
                i18n-placeholder="Placeholder for email or phone form input@@EMAIL_OR_PHONE"
                autocapitalize="none"
                #inputLogin
              />
            </div>
          } 
          @if(inputs.password) {
            <div class="input-holder">
              <button type="button" class="password-btn" (click)="showHidePassword()" [class.showHide]="!showPassword">
                <span class="material-symbols-outlined password-icon">
                  visibility
                </span>
              </button>
              <button type="button" class="password-btn" (click)="showHidePassword()" [class.showHide]="showPassword">
                <span class="material-symbols-outlined password-icon">
                  visibility_off
                </span>
              </button>

              <input
                id="password"
                [type]="showPassword ? 'text': 'password'"
                formControlName="passwordCtrl"
                placeholder="Password"
                i18n-placeholder="Placeholder for password form input@@PASSWORD"
                autocapitalize="none"
                #inputPassword
              />

              @if(showPassword){
                <div class="show-password">{{ authFormGroup.value.password }}</div>
              }
            </div>
          }

          <button
            class="submit"
            [class.wrong]="wrongCredential"
            type="submit"
            [disabled]="formStatus === 'INVALID'"
            i18n="Text for login form submit button@@LOG_IN"
          >
            Log In
          </button>
          
          @if(inputs.password) {
            <button type="button" class="text-link" [routerLink]="['/forgotten-password']" routerLinkActive="active" i18n="Text for the link to the forgotten password form@@FORGOT_PASSWORD_?">
              Forgot your password?
            </button>
          }
        </div>

        @if(loading$ | async){
          <app-loader></app-loader>
        }
      </form>

      @if(registrationNeeded$ | async){
        <div class="user-exists">
          <p i18n="@@ALREADY_ACCOUNT_POPUP">
            You already have an account. Please log in to this account to access the service. 
            As a reminder, here is your login: {{authFormGroup.controls['loginCtrl'].value}}. Have you forgotten your password?
          </p>
        
          <button class="button reset-link" [routerLink]="['/forgotten-password']" i18n="@@ALREADY_ACCOUNT_POPUP_LINK_PASSWORD">Click here to reset it.</button>
        </div>
      }
      <div class="field signup">
          <h3 i18n="Title for section when the user has no account@@NO_ACCOUNT">No account?</h3>
          <button
            class="text-btn"
            [routerLink]="['/subscribe-step-one']"
            queryParamsHandling="merge"
            i18="Text for the button to access the subscription process@@JOIN_US"
          >
            Join us now!
          </button>
      </div>
    </div>

    <app-footer></app-footer>
  </div>
</div>
  